jQuery(document).ready(function($) {
    'use strict';

    $('.grid-swiper').each(function(index) {
        var $swiperObject = $(this);
        var swiperId = 'grid-swiper-' + index;
        var paginationId = 'grid-pagination-' + index;
        var nextId = 'grid-next-' + index;
        var prevId = 'grid-prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-pagination').attr('data-id', paginationId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        var swiperSelector = '[data-id="' + swiperId + '"]';
        var paginationSelector = '[data-id="' + paginationId + '"]';
        var nextSelector = '[data-id="' + nextId + '"]';
        var prevSelector = '[data-id="' + prevId + '"]';

        const grid_swiper = new Swiper(swiperSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            grabCursor: true,
            speed: 700,
            pagination: {
                el: paginationSelector,
                type: 'progressbar',
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                    slidesOffsetBefore: 48,
                    slidesOffsetAfter: 48,
                },
                1280: {
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            }
        });

    });

});
//# sourceMappingURL=swiper-grid.js.map
